export default __webpack_public_path__ + "static/media/3q_b.d2cdee8f.png";